import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { CommonService } from "../../api/index";
import { SnackService } from "../../services/index";
import { NgForm } from "@angular/forms";
import { Communications, Communication_channel } from "../../interfaces/index";

@Component({
    selector: 'school-communication-ui',
    templateUrl: './communication-ui.component.html',
    styleUrls: ['./communication-ui.component.scss']
})
export class CommunicationUiComponent implements OnInit, OnDestroy {
    EmailComplete: boolean = false;
    SMSComplete: boolean = false;
    PhoneComplete: boolean = false;


    communication = {} as Communications;
    @ViewChild("communicationForm", { static: false }) communication_Form: NgForm;

    @Input() formtype: string;
    @Output() accordionEvent = new EventEmitter();
    @Input() isExpand: any;

    constructor(private route: Router,
        private _userService: CommonService,
        private _snackService: SnackService,) { }

    ngOnInit(): void {
        this.communication.communication_channel = {} as Communication_channel;
    }

    ngOnDestroy(): void {
        this.accordionEvent.unsubscribe();
    }

    ngOnChanges(): void {
        if (this.isExpand == true) {
            this.LoadData();
        }
    }

    LoadData() {

        this._userService.getLoginUserInfos().subscribe(
            result => {
                this.communication.communication_channel = result.body.data.communication_channel;

                if (!result.body.data.communication_channel) {
                    this.communication = {} as Communications;
                    this.communication.communication_channel = {} as Communication_channel;
                }

            }, error => {
                this._snackService.openSnackBar("danger", "Failed to Load updated data..");
            });
    }

    onSubmit(): void {

        const saveData = { ...this.communication };

        this._userService.savecommunication(saveData).subscribe(
            result => {
                this._snackService.openSnackBar("success", "Communication updated Successfully!...");

            }, error => {
                this._snackService.openSnackBar("danger", "Failed to update a Communication..");
            });
    }


    cancelClick() {
        if (this.formtype == 'accordion') {

            this.accordionEvent.emit(false);
        }
        else {
            this.route.navigate([`/${this.formtype}`]);
        }
    }


}
